<template>
    <paper id="agingProduct">
        <m-pane
            ref="tablePage"
            :config="config"
            :loading="loading"
            :pageTotal="pageTotal"
            :searchTotalTitle="searchTotalTitle"
            :totalData="totalData"
            pageID="trainList"
            searchId="trainList"
            @btnClick="handleClickCell"
            @pageChange="handlePageChange"
            @searchChange="handleSearch"
            @selectChange="handleSelect"
            @sizeChange="handleSizeChange"
            @arrange-btn="handleArrangeBtn"
            @row-db-click="rowDBClick"
        >
            <div slot="table-module-btn" class="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT_TRAIN_LIST_CONFIG"
                >
                    <el-tooltip content="导出" effect="dark" placement="bottom">
                        <span v-has="'otp02020003'" class="mgl-5">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="handleExport(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    v-has="'otp02020001'"
                    type="primary"
                    @click="handleToAdjust"
                    >调整</el-button
                >
                <el-button
                    v-has="'otp02020002'"
                    type="primary"
                    @click="handleInvalidate"
                    >作废</el-button
                >
            </div>
        </m-pane>
        <car-scheduling-dialog
            v-if="isArrangeSubmitVisi"
            ref="carScheduling"
            :RwCarVisiable.sync="isArrangeSubmitVisi"
            :inOutType="currInOutType"
            :taskDataList="taskDataList"
            :dispatchSaveFlag="dispatchSaveFlag"
            :checkDispatch="checkDispatch"
            label-task="right"
            @AdmittOk="handleArrangeSubmitOk"
        >
        </car-scheduling-dialog>
         <!-- 快销预排车 -->
        <quick-cancellation-dialog
            :quickCancellationVisiable.sync="quickCancellationVisiable"
            v-if="quickCancellationVisiable"
            :taskDataList="taskDataList"
            @AdmittOk="handleArrangeSubmitOk"
        >
        </quick-cancellation-dialog>
    </paper>
</template>
<script>
import MPane from '@/components/otpPanel';
import config from './config.js';
import Paper from '@/components/core/paper/Paper';
import formatTime from '@/utils/common.js';
import CarSchedulingDialog from '../../../components/dialog/carSchedulingDialog';
import * as api from '../../../api/trainList';
import { PromiseUtils } from './utils/promise';
import { ProcurementChannelTranslator, TrainStatus, TrainStatusNameTranslator } from './utils/train';
import { StatusValue } from './utils/statusValue';
import { showCopiableMessage } from './utils/message';
import reportExport from '@/components/lots/reportExportPlugin';
import { TrainEntity } from './entity/trainEntity';
import { validationAssert } from './utils/helpers';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import QuickCancellationDialog from '../../../components/dialog/QuickCancellationDialog';

export default {
    name: 'trainList',
    components: { MPane, Paper, CarSchedulingDialog, reportExport, QuickCancellationDialog },
    data () {
        return {
            config: config,
            selectedData: [],
            taskDataList: [], // 点击排车时，该车次包含的运输单
            totalData: [],
            loading: false,
            searchTotalTitle: config.searchTotalTitle,
            searchParams: {},
            pageTotal: 0,
            pageSize: 10,
            pageNo: 1,
            // 待排车的行
            rowsToArrange: [],
            // 排车弹窗是否展示
            isArrangeSubmitVisi: false,
            dispatchSaveFlag: true, // 行排车点击标识，true为算法排车，false为线路排车
            checkDispatch: true,// 开启排车承运商限制
            quickCancellationVisiable: false // 快销预排车
        };
    },
    created () {
        this.messenger = PromiseUtils.buildErrorMessenger(this.$message);
    },
    mounted () {
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        // "订单大类", 'IN' 为入库, 字典: IN_OUT_TYPE
        currInOutType () {
            return this.rowsToArrange.length > 0 ? this.rowsToArrange[0].inOutType : 'IN';
        },
        ...mapState({
            supplier: state => state.supplier,
        })
    },
    methods: {
        /// 接口获取数据
        getList (params) {
            this.loading = true;
            this.searchParams = (params || this.searchParams);
            const searchParams = {
                ...this.searchParams,
                pageSize: this.pageSize,
                pageNo: this.pageNo,
                // 排序
                orderBy: 'createTime',
                orderByType: 'desc'
            };
            return api.search(searchParams) // 查询列表
                .then(async (res) => {
                    PromiseUtils.assertResponseSuccessWithData(res);

                    const tsTranslator = await TrainStatusNameTranslator.create();
                    const pcTranslator = await ProcurementChannelTranslator.create();

                    // 处理返回数据
                    this.totalData = res.data.list.map(item => {
                        // 根据状态处理操作按钮
                        // 只有车次状态是"待排车"时, 显示"排车"按钮
                        if (StatusValue.create(+item.dispatchStatus).isNot(TrainStatus.TO_ARRANGE)) {
                            item.hiddenEvent = ['arrange'];
                        }
                        // 转换 状态名称
                        item.dispatchStatusName = tsTranslator.toName(item.dispatchStatus, item.dispatchStatus);
                        // 转换 采购渠道
                        item.procurementChannelName = pcTranslator.toName(item.procurementChannel, item.procurementChannel);
                        item.volumeRates = Math.round((item.volumeRate + Number.EPSILON) * 10000) / 100 + '%';
                        item.vehicleCardAndEquipmentName = (item.vehicleCard || '') + ' / ' + (item.equipmentName || '');
                        item.driverAndDriverContactWay = (item.driver || '') + ' / ' + (item.driverContactWay || '');
                        return item;
                    });
                })
                .then(() => {
                    return api.searchCount(searchParams); // 查询总数
                })
                .then(res => {
                    PromiseUtils.assertResponseSuccessWithData(res);
                    this.pageTotal = res.data;
                })
                .catch(err => {
                    this.messenger.w(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /// format search params
        formatParams (params) {
            // 处理"创建时间"
            if (params.createTime && params.createTime.length > 0) {
                params.beginDate = formatTime.formatDateTime(params.createTime[0]);
                params.endDate = formatTime.formatDateTime(params.createTime[1]);
            } else if (!params.createTime) {
                params.beginDate = '';
                params.endDate = '';
            }
            const beginDate = dayjs(params.beginDate).valueOf() || 0;
            const endDate = dayjs(params.endDate).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            const maxDay63 = 1000 * 60 * 60 * 24 * 63;
            if (differenceValue > maxDay63) {
                this.$message.warning('按时间查询或导出时，查询或导出时间跨度不可超过两个月！');
                return false;
            }
            delete params.createTime;
            return params;
        },
        /// 点击查询
        handleSearch (params) {
            const param = this.formatParams(params);
            param && this.getList(param);
        },
        /// 表格选择变化
        handleSelect (rows) {
            this.selectedData = rows;
        },
        /// 分页器页数变化
        handlePageChange (pageNo) {
            this.pageNo = pageNo;
            this.getList();
        },
        /// 分页器页数大小变化
        handleSizeChange (pageSize) {
            this.pageSize = pageSize;
            this.pageNo = 1;
            this.getList();
        },
        /// 点击单元格
        handleClickCell (val, index, row) {
            // this.handleToDetail(trainNum);
            this.copyText(document.body, val, false);
        },
        // 双击
        rowDBClick (row) {
            this.handleToDetail(row.trainNum);
        },
        /// 进入详情页面
        handleToDetail (trainNum) {
            this.$router.push({
                query: { trainNum },
                path: '/otp/dispatch-Manage/train-list-detail'
            });
        },
        // 复制函数
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        /// 进入调整页面
        handleToAdjust () {
            return Promise.resolve(this.selectedData)
                .then(rowsToAdjust => {
                    PromiseUtils.assert(rowsToAdjust.length > 0, '请选择需要调整的车次');
                    validationAssert(TrainEntity.toAdjustPreCheck(rowsToAdjust));

                    return this.selectedData.map(r => r.trainNum);
                })
                .then(trainNums => {
                    this.$router.push({
                        query: { trainNums: trainNums.join(',') },
                        path: '/otp/dispatch-Manage/train-list-adjust'
                    });
                })
                .catch(err => {
                    this.messenger.w(err);
                });
        },
        /// 作废
        handleInvalidate () {
            return Promise.resolve(this.selectedData)
                // 验证参数
                .then(PromiseUtils.do((selectedData) => {
                    validationAssert(TrainEntity.invalidatePreCheck(selectedData));
                }))
                // 弹框确认
                .then(selectedData => {
                    return this.$confirm('请确认是否作废选中的数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => selectedData)
                        .catch(() => PromiseUtils.failSilently());
                })
                // 调用接口
                .then(selectedData => api.cancel(selectedData)) // cancel 的参数是选中的数据组成的数组
                // 验证Response
                .then(PromiseUtils.assertResponseSuccess)
                // 提示成功，重新获取数据
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('作废成功');
                        this.getList();
                    }
                })
                // 错误处理
                .catch(err => {
                    this.messenger.w(err);
                });
        },
        // 导出
        handleExport (submit) {
            const params = {
                ...this.searchParams
            };
            if (params.beginDate === '' || params.endDate === '') {
                delete params.beginDate;
                delete params.endDate;
            }
            // hack: 后台需要必填 beginDate 或 beginDate2, 且beginDate 不会被使用,
            // 所以可以填一个时间，但是格式要正确
            // endDate, endDate2 也一样
            params.beginDate2 = '2021-09-25 00:00:00';
            params.endDate2 = '2021-09-25 00:00:00';
            params.suppliersCode = this.supplier.supplierCode,
            submit(params);
        },
        /// 点击排车按钮
        handleArrangeBtn (row) {
            this.rowsToArrange = [row];
            api.lineDetailWithOrder({ trainNumList: row.trainNum }).then(res => {
                if (res && +res.code === 0) {
                    this.taskDataList = res.data.list[0].lineOrderResponseList;
                    // 快销判断，特殊排车
                    if (this.taskDataList.some(i => i.projectClassify === 'QCO')) {
                        this.quickCancellationVisiable = true;
                        return false;
                    }
                    this.isArrangeSubmitVisi = true;
                    const params = {
                        carrierName: this.taskDataList[0].carrierName,
                        carrierCode: this.taskDataList[0].carrierCode,
                        supplierCode: this.taskDataList[0].carrierCode,
                        transType: this.taskDataList[0].procurementChannel,
                        tranName: this.taskDataList[0].procurementChannelName,
                        siteCode: this.taskDataList[0].siteCode,
                        transUnitName: this.taskDataList[0].transUnitName,
                        transUnitCode: this.taskDataList[0].transUnitCode,
                        paymentTerms: this.taskDataList[0].paymentTerms,
                        transportContractNo: this.taskDataList[0].transportContractNo
                    };
                    this.$nextTick(() => {
                        this.$refs.carScheduling.AdmittRuleForm.carrierName = this.taskDataList[0].carrierName;
                        this.$refs.carScheduling.AdmittRuleForm.companyCode = this.taskDataList[0].companyCode;
                        this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.taskDataList.filter(item => item.lineCode).map(item => item.lineCode);
                        this.$refs.carScheduling.AdmittRuleForm.siteCodeList = this.taskDataList.filter(item => item.siteCode).map(item => item.siteCode);
                        this.$refs.carScheduling.getAdvanceValueLists(params);
                    });
                }
            });
        },
        /// 处理排车弹框确认按钮
        handleArrangeSubmitOk (data) {
            if (data.state) {
                const params = data.data;
                params.preDispatchType = '2';
                const carSchedulingDialog = this.$refs.carScheduling;
                return Promise.resolve(this.rowsToArrange[0])
                    // 设置弹框显示效果
                    .then(PromiseUtils.do(() => {
                         if (params.preDispatchStrategy !== 'FMCG') {
                            this.isArrangeSubmitVisi = true;
                            carSchedulingDialog.saveLoading = true;
                        }
                    }))
                    // 参数
                    .then((train) => {
                        return {
                            ...params, // 弹框数据
                            trainNum: train.trainNum // 车次号
                        };
                    })
                    .then(api.save) // 调用排车接口
                    .then(PromiseUtils.assertSilently) // 确保 res 不为 null
                    .then(res => {
                        const codeNumber = +res.code;
                        if (codeNumber === 0 && typeof res.data === 'string') {
                            const dispatchNo = res.data.split(',')[0];
                            if (params.procurementChannel === '190') {
                                // "采购渠道" 为 “城配长合车”, 跳转到 “配送中心-发车单管理” 并展示“行车路径调整”弹框
                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'dispatchOrder',
                                        params: {
                                            name: '/dispatch-order',
                                            dispatchNo: dispatchNo,
                                            carrierName: params.carrierName
                                        }
                                    });
                                }, 200);
                            }
                            showCopiableMessage(this.$message, `已保存，生成发车单号：${res.data}`, dispatchNo);
                            if (params.vehicleCard && params.vehicleCard !== '*') {
                                this.getPromptTrackType(dispatchNo);
                            }
                            return true;
                        } else if (codeNumber === 200) {
                            // TODO: 这个判断条件应该解释一下
                            this.$message.error(res.msg || '');
                            return true;
                        }

                        return false;
                    })
                    .then((shouldHideDialog) => {
                        if (shouldHideDialog) {
                            this.isArrangeSubmitVisi = false;
                            this.quickCancellationVisiable = false;
                            /// 重新查询数据
                            this.getList();
                        }
                    })
                    .catch((err) => {
                        this.messenger.w(err, '排车失败');
                    })
                    .finally(() => {
                        if (params.preDispatchStrategy !== 'FMCG') {
                            carSchedulingDialog.saveLoading = false;
                        }
                    });
            }
        },
        getPromptTrackType (dispatchNo) {
            api.promptTrackType(dispatchNo).then(res => {
                if (res && +res.code === 0 && res.data && +res.data.shippingType === 1) {
                    if (+res.data.isZjxl === 0) {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                    } else if (+res.data.isZjxl === 1) {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                    } else {
                        this.$message.warning('未知车辆北斗入网状态，请要求司机全程打开直通宝');
                    }
                }
            });
        },
    }
};
</script>
